import React, { useState, useMemo, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Dropdown, Space, Typography, Popover } from 'antd'
import { Briefcase12Regular, ChevronDown12Regular } from '@fluentui/react-icons'
import { formatCapitalizedString } from '@choreograph/layout'

import { selectNamespace, setNamespace } from '../state/slices/appSlice'
import { useGetNamespacesQuery } from '../state/apis/generated/namespacesApi'

export const NamespaceSelector = () => {
  const { data: namespaceData = [] } = useGetNamespacesQuery()
  const [open, setOpened] = useState(false)
  const dispatch = useDispatch()
  const namespace = useSelector(selectNamespace)

  const namespaceItems = useMemo(() => (
    (namespaceData as string[]).map(n => ({ key: n, label: formatCapitalizedString(n) }))
  ), [namespaceData])

  useEffect(() => {
    if (namespaceItems.length === 1) {
      const key = namespaceItems[0].key
      dispatch(setNamespace(key))
    }
  }, [namespaceItems, namespace, dispatch])

  return (
    <Popover
      placement='bottom'
      align={{ offset: [0, 16] }}
      classNames={{ body: 'namespace-popover' }}
      content='Select a namespace to enable controls'
      open={!namespace && !open}>
      <div className='namespace-layout'>
        <div className={`namespace${open ? ' opened' : ''}`}>
          <Dropdown
            trigger={['click']}
            onOpenChange={(e) => setOpened(e)}
            menu={{
              items: namespaceItems,
              selectable: true,
              selectedKeys: namespace ? [namespace.id] : [],
              onSelect: ({ key }) => {
                dispatch(setNamespace(key ?? null))
              }
            }}>
            <Typography.Link>
              <Space className={namespace ? 'selected' : ''}>
                <Briefcase12Regular className='customized-icon' />
                {namespace ? formatCapitalizedString(namespace) : 'Select a Namespace'}
                <ChevronDown12Regular className='customized-icon rotated' />
              </Space>
            </Typography.Link>
          </Dropdown>
        </div>
      </div>
    </Popover>
  )
}

export default NamespaceSelector
